import { ɵɵdefineInjectable, ɵɵinject, Injectable, Optional, Inject } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
const FEATURE_FLAGS_TOKEN = 'AdsFeatureFlags';
class FeatureFlagsService {
    constructor(adsFeatureFlags) {
        this.adsFeatureFlags = adsFeatureFlags;
        if (adsFeatureFlags) {
            this._flags = adsFeatureFlags;
            if (Object.prototype.hasOwnProperty.call(this._flags, 'global')) {
                this._globalFlags = this._flags.global;
                this._applyGlobalFeatureFlags();
            }
        }
    }
    getFlags(component) {
        return this._flags ? this._flags[component] : undefined;
    }
    _applyGlobalFeatureFlags() {
        if (this._globalFlags) {
        }
    }
}
FeatureFlagsService.ɵfac = function FeatureFlagsService_Factory(t) { return new (t || FeatureFlagsService)(ɵngcc0.ɵɵinject(FEATURE_FLAGS_TOKEN, 8)); };
FeatureFlagsService.ɵprov = ɵɵdefineInjectable({ factory: function FeatureFlagsService_Factory() { return new FeatureFlagsService(ɵɵinject("AdsFeatureFlags", 8)); }, token: FeatureFlagsService, providedIn: "root" });
FeatureFlagsService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [FEATURE_FLAGS_TOKEN,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FeatureFlagsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [FEATURE_FLAGS_TOKEN]
            }] }]; }, null); })();

export { FEATURE_FLAGS_TOKEN, FeatureFlagsService };

//# sourceMappingURL=aw-ads-components-src-services-feature-flags.js.map